/* Rquiere de mixin.js */

var entity = {
	data () {
		return {
			listEntities: [],
			methodsEntity: {
				get: 'entities',
				show: 'entity/',
			},
			paginationEntities: [],
			searchEntities: '',
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		getAllEntities(page = 1) {
			let parameters = '?search=' + this.searchEntities + '&page=' + page
			this.axiosActionIS(this.apiBackend + this.methodsEntity.get + parameters, 'GET', 'getAllEntitiesResult')
        },
		getAllEntitiesResult(response) {
            if(response.data.success === true) {
                this.listEntities = response.data.data
                this.paginationEntities = response.data.paginate    
            }
            this.getAllEntitiesResultLocal(response)
		},
        getAllEntitiesResultLocal(response) {
            console.log('getAllEntitiesResultLocal no desarrollado', response)
        },
		getEntity(id) {
			this.axiosActionIS(this.apiBackend + this.methodsEntity.show + id, 'GET', 'getEntityResult')
		},
        getEntityResult(response) {
            this.getEntityResultLocal(response)
        },
        getEntityResultLocal(response) {
            console.log('getEntityResultLocal no está desarrollado', response)
        },
	},
};

export default entity;